import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]
  static values = { keys: Array }

  addFilter(event) {
    event.preventDefault()
    const index = this.containerTarget.children.length
    const html = this.buildFilterRow(index)
    this.containerTarget.insertAdjacentHTML("beforeend", html)
  }

  removeFilter(event) {
    event.preventDefault()
    event.currentTarget.closest("[data-filter-row]").remove()
  }

  buildFilterRow(index) {
    const options = this.keysValue.map(key =>
      `<option value="${this.escapeHtml(key)}">${this.escapeHtml(key)}</option>`
    ).join("")

    return `<div data-filter-row class="flex items-center gap-2 mb-2">
      <select name="answer_filters[][key]" class="rounded-lg border border-gray-300 px-3 py-1.5 text-sm shadow-sm focus:border-indigo-500 focus:ring-indigo-500">
        <option value="">設問を選択</option>
        ${options}
      </select>
      <input type="text" name="answer_filters[][value]" placeholder="値" class="rounded-lg border border-gray-300 px-3 py-1.5 text-sm shadow-sm focus:border-indigo-500 focus:ring-indigo-500 w-32">
      <button type="button" data-action="click->answer-filter#removeFilter" class="text-gray-400 hover:text-red-500 cursor-pointer">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
      </button>
    </div>`
  }

  escapeHtml(str) {
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
